{
  "lead": "Posts, services, offices, guides, tourism, documents and more, in one place.",
  "label": "Search the app",
  "placeholder": "What are you looking for?",
  "hint": "Type at least two letters.",
  "noResults": "Nothing found for \"{q}\"",
  "noResultsHint": "Try a shorter word, or check the spelling.",
  "resultCount": "{count} results",
  "type_post": "Posts and events",
  "type_service": "Services",
  "type_office": "Offices and barangays",
  "type_guide": "Town guides",
  "type_market": "Market prices",
  "type_facility": "Facilities",
  "type_proposal": "Proposals",
  "type_lost_found": "Lost & found",
  "type_tourist_spot": "Tourist spots",
  "type_trail": "Trails",
  "type_document": "Documents",
  "type_bid": "Bids and awards",
  "type_ordinance": "Ordinances and resolutions",
  "type_official": "Officials"
}
